function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import PropTypes from "prop-types";
import React, { Component } from "react";
import classnames from "classnames";
import Base from "../Base/Base";
import TextIcon from "../Typography/TextIcon";
import EllipsisTooltip from "../EllipsisTooltip/EllipsisTooltip";
export default class TableHeaderLabel extends Component {
  render() {
    const {
      children,
      className,
      grow,
      onClick,
      shrink,
      sortDirection,
      textAlign,
      sortable,
      width,
      wrap,
      ...rest
    } = this.props;
    const classes = classnames("ax-table__header-label", `ax-table__header-label--align-${textAlign}`, {
      "ax-table__header-label--grow": grow && !width,
      "ax-table__header-label--selected": sortDirection !== undefined,
      "ax-table__header-label--shrink": shrink && !width
    }, className);
    const styles = (rest.style || width) && { ...rest.style,
      ...(width && {
        width: `${Math.max(0, Math.min(width, 100))}%`
      })
    };
    const buttonClasses = classnames("ax-table__header-button", {
      "ax-table__header-button--disabled": !onClick
    });
    return /*#__PURE__*/React.createElement(Base, _extends({}, rest, {
      Component: "th",
      className: classes,
      style: styles
    }), /*#__PURE__*/React.createElement("div", {
      className: buttonClasses,
      onClick: onClick,
      role: "button",
      "aria-disabled": !onClick
    }, wrap ? /*#__PURE__*/React.createElement(EllipsisTooltip, {
      className: "ax-table__header-tooltip--wrap"
    }, children) : children, sortable && /*#__PURE__*/React.createElement(TextIcon, {
      className: "ax-table__header-icon",
      cloak: sortDirection === undefined,
      name: sortDirection === "descending" ? "triangle-down" : "triangle-up",
      spaceLeft: textAlign === "left" ? "x2" : undefined,
      spaceRight: textAlign === "right" ? "x2" : undefined
    })));
  }

}

_defineProperty(TableHeaderLabel, "defaultProps", {
  textAlign: "left",
  sortable: true,
  wrap: false
});